import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { PublisherCollectingSocietyViewStore } from "../../store";
import { PublisherCollectingSocietyView } from "../view/PublisherCollectingSocietyView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type PublisherCollectingSocietyModalContentProps = {
  entityId: string;
  mode: "view" | "update";
  onClose: () => void;
};

export const PublisherCollectingSocietyModalContent: React.FC<PublisherCollectingSocietyModalContentProps> =
  observer(({ entityId, mode, onClose }) => {
    const rootStore = useRootStore();
    const initializedRef = useRef<string | null>(null);

    const storeInfo = useMemo(() => {
      // Default to view mode
      const s = new PublisherCollectingSocietyViewStore(rootStore);
      s.isModalMode = true;
      return { store: s, type: "view" as const };
    }, [rootStore]);

    useEffect(() => {
      if (entityId && initializedRef.current !== entityId) {
        initializedRef.current = entityId;
        storeInfo.store.initialize({ id: entityId });
      }
    }, [entityId, storeInfo]);

    useEffect(() => {
      return () => {
        storeInfo.store.destroy();
      };
    }, [storeInfo]);

    const store = storeInfo.store;
    if (store.status === "processing" || store.status === "uninitialized") {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <Box sx={{ p: 2 }}>
        {storeInfo.type === "view" && (
          <PublisherCollectingSocietyView
            publisherCollectingSocietyViewStore={
              storeInfo.store as PublisherCollectingSocietyViewStore
            }
          />
        )}
      </Box>
    );
  });
